export interface Slider {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptySlider = (): Slider => ({
  id: 0,
  name: '',
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const sliderFromResponse = (responseData: any): Slider => ({
  id: responseData.id,
  name: responseData.name,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const sliderToUpsertRequest = (slider: Slider) => ({
  name: slider.name,
});
